module.exports = __webpack_public_path__ + "media/loans/student-writing-97fded5f.jpg";